export default {
  default: {
    readPercentage: {
      value: '{percentage}%',
      title: 'Average Read Percentage',
    },
  },
}
